import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

// Table
import EmployeeAttachmentTable from "../../../DataTables/Workforce/Employees/EmployeeAttachment";

// Modals
import UploadAttachments from "../../../UiKits/Modal/Employee/UploadAttachments";
import CreateNoteModal from "../../../UiKits/Modal/Employee/CreateNotes";

// Card
import EmployeeNotes from "./EmployeeNotes";

//Type
import { CRUDPermissions } from "../../../../Types/Common/Access";

interface EmployeeProfileProps {
  EmpNo: string;
  access: CRUDPermissions;
}

const EmployeeAttchment: React.FC<EmployeeProfileProps> = ({
  EmpNo,
  access,
}) => {
  return (
    <Row>
      <Col sm="12">
        <Card className="card-absolute">
          <CommonCardHeader
            headClass="bg-primary"
            tagClass="txt-light"
            icon={<i className="icofont icofont-clip me-1"></i>}
            title={"Attachments"}
          />
          <CardBody>
            {access.create && <UploadAttachments EmpNo={EmpNo} />}
            <EmployeeAttachmentTable EmpNo={EmpNo} access={access} />
          </CardBody>
        </Card>
      </Col>

      <Col sm="12">
        <Card className="card-absolute">
          <CommonCardHeader
            headClass="bg-primary"
            tagClass="txt-light"
            icon={<i className="icofont icofont-paper me-1"></i>}
            title={"Remarks"}
          />
          <CardBody>
            {access.create && <CreateNoteModal EmpNo={EmpNo} />}
            <EmployeeNotes EmpNo={EmpNo} access={access} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};
export default EmployeeAttchment;
